import { Student } from "@/types/user.types"
import Close from "@mui/icons-material/Close"
import PersonAddIcon from "@mui/icons-material/PersonAdd"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import IconButton from "@mui/material/IconButton"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"

export const AddStudentModal = ({ openModal, handleAddStudent, handleCloseModal, setErrors, errors }: {
    openModal: boolean, handleAddStudent: (student: Student) => void, handleCloseModal: () => void, setErrors: React.Dispatch<React.SetStateAction<{
        name: string;
        id: string;
    }>>, errors: { name: string; id: string; }
}) => {

    const [newStudent, setNewStudent] = useState({
        id: "",
        name: "",
    });

    const validateForm = (): boolean => {
        const newErrors = { name: "", id: "" };
        let isValid = true;

        if (!newStudent.name.trim()) {
            newErrors.name = "El nombre es requerido";
            isValid = false;
        }

        if (!newStudent.id.trim()) {
            newErrors.id = "El documento es requerido";
            isValid = false;
        } else if (!/^\d+$/.test(newStudent.id)) {
            newErrors.id = "Solo se permiten números";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };


    const addStudent = () => {
        if (!validateForm()) return;

        const student: Student = {
            id: newStudent.id,
            name: newStudent.name.trim(),
            documentId: newStudent.id.trim(),
        };

        handleAddStudent(student);
        setNewStudent({ id: "", name: "" });
        handleCloseModal();
    };

    return <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
            sx: {
                borderRadius: "12px",
            },
        }}
    >
        <DialogTitle
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignContent: "center",
                pb: 1,
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 1, width: "100%", py: 4 }}>
                <PersonAddIcon sx={{ color: "primary.dark" }} />
                <Typography variant="h6" fontWeight={600} sx={{ textAlign: "center", color: "primary.dark" }}>
                    Agregar Estudiante
                </Typography>
            </Box>

            <IconButton
                onClick={handleCloseModal}
                size="small"
                sx={{
                    color: "#666",
                }}
            >
                <Close />
            </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 2, px: 8 }}>
            {/* Nombre */}
            <Typography
                fontWeight={550}
                fontSize={14}
                sx={{ mb: 0.5, color: "grey.600", pb: 1 }}
            >
                Nombre del Estudiante
            </Typography>
            <TextField
                fullWidth
                placeholder="Ingrese nombre completo"
                value={newStudent.name}
                onChange={(e) =>
                    setNewStudent((prev) => ({ ...prev, name: e.target.value }))
                }
                error={Boolean(errors.name)}
                helperText={errors.name}
                sx={{
                    pb: 2
                }}
                InputProps={{
                    sx: {
                        backgroundColor: "#fafafa",
                        mb: 2,
                        borderRadius: "8px",
                        "& fieldset": { border: "none" },
                        height: "40px",
                    },
                }}
            />

            {/* Documento */}
            <Typography
                fontWeight={550}
                fontSize={14}
                sx={{ mb: 0.5, color: "grey.600", pb: 1 }}
            >
                Número de Documento
            </Typography>
            <TextField
                fullWidth
                placeholder="Ingrese número de documento"
                value={newStudent.id}
                onChange={(e) =>
                    setNewStudent((prev) => ({
                        ...prev,
                        id: e.target.value,
                    }))
                }
                error={Boolean(errors.id)}
                helperText={errors.id}
                sx={{
                    pb: 2
                }}
                InputProps={{
                    sx: {
                        backgroundColor: "#fafafa",
                        borderRadius: "8px",
                        "& fieldset": { border: "none" },
                        height: "40px",
                    },
                }}
            />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
            <Button
                onClick={addStudent}
                variant="contained"
                sx={{
                    fontWeight: 600,
                    textTransform: "none",
                    backgroundColor: "primary.main",
                    "&:hover": {
                        backgroundColor: "primary.dark",
                    },
                    color: "white",
                }}
            >
                Agregar Estudiante
            </Button>
        </DialogActions>
    </Dialog>
}